/** @jsx jsx */
import { token } from '@atlaskit/tokens';
import { cssMap, jsx } from '@atlaskit/css';
import HighlightText from '@atlassian/jira-software-highlight-text/src/ui/index.tsx';

type Props = {
	highlight?: string[];
	text: string;
};

export const CardSummary = ({ highlight, text }: Props) => {
	return (
		<div css={styles.root}>
			<span css={styles.summary}>
				<HighlightText highlight={highlight ?? null} text={text} />
			</span>
		</div>
	);
};

export default CardSummary;

const styles = cssMap({
	root: {
		boxSizing: 'border-box',
		display: 'flex',
		paddingBlock: token('space.100'),
		paddingInline: token('space.150'),
		// min height is set to match action menu button height + padding
		minHeight: '48px',
	},
	summary: {
		overflowWrap: 'break-word',
		paddingRight: token('space.400'),
		wordBreak: 'break-word',
		wordWrap: 'break-word',
	},
});
